'use strict';

import './component.scss';

function init() {
    // const tripSummaryBar = document.querySelector('.trip-summary-bar-container');

    // if (tripSummaryBar) {
    //     detectWorkflow(tripSummaryBar);
    //     dragTripSummaryElements();
    // }

    (function () {
        const summaryBar = document.querySelector('.trip-summary-bar-container');
        if (summaryBar) {
            const footer = document.querySelector('.page-footer')

            const ro = new ResizeObserver(entries => {
                const rect = entries[0].contentRect;
                const isTall = rect.height >= 81;
                footer.classList.toggle('summary-bar-two-rows', isTall);
            });

            ro.observe(summaryBar);
        }
    })();

}

// function detectWorkflow(tripSummaryBar) {
//     if (tripSummaryBar.classList.contains('air-flow')) {
//         air(tripSummaryBar);
//     } else if (tripSummaryBar.classList.contains('hotel-flow')) {
//         hotel(tripSummaryBar);
//     } else if (tripSummaryBar.classList.contains('car-flow')) {
//         car(tripSummaryBar);
//     }
// }

// function air(tripSummaryBar) {
//     console.log("air flow");
// }

// function hotel(tripSummaryBar) {
//     console.log("hotel flow");
// }

// function car(tripSummaryBar) {
//     switch (tripSummaryBar.id) {
//         case 'car_select_station_page': selectStation();
//         break;
//     }

//     function selectStation() {
//         const continueButton = document.querySelector('#continue-button');

//         onElementReady('.button-row-container .button-find-options', enableDisableContinueBtn.bind(null, continueButton));
//     }
// }

// function onElementReady(selector, callback) {
//     const el = document.querySelector(selector);
//     if (el) {
//         callback(el);
//         return;
//     }

//     const observer = new MutationObserver(() => {
//         const found = document.querySelector(selector);
//         if (found) {
//             callback(found);
//             observer.disconnect();
//         }
//     });

//     observer.observe(document.body, {
//         childList: true,
//         subtree: true,
//     });
// }

// function enableDisableContinueBtn(continueButton, hiddenSubmit) {
//     if (!hiddenSubmit.disabled) {
//         continueButton.removeAttribute('disabled');
//     }

//     const observer = new MutationObserver(() => {
//         const isEnabled = !hiddenSubmit.disabled;

//         if (isEnabled) {
//             continueButton.removeAttribute('disabled');
//         } else {
//             continueButton.setAttribute('disabled', 'disabled');
//         }
//     });

//     observer.observe(hiddenSubmit, {
//         attributes: true,
//         attributeFilter: ['disabled'],
//     });
// }

// function dragTripSummaryElements() {
// const container = document.querySelector('.trip-summary-items');
// let isDown = false;
// let startX;
// let scrollLeft;

// container.addEventListener('mousedown', (e) => {
//   isDown = true;
//   container.classList.add('dragging');
//   startX = e.pageX - container.offsetLeft;
//   scrollLeft = container.scrollLeft;
// });

// container.addEventListener('mouseleave', () => {
//   isDown = false;
//   container.classList.remove('dragging');
// });

// container.addEventListener('mouseup', () => {
//   isDown = false;
//   container.classList.remove('dragging');
// });

// container.addEventListener('mousemove', (e) => {
//   if (!isDown) return;
//   e.preventDefault();
//   const x = e.pageX - container.offsetLeft;
//   const walk = (x - startX) * 2; // The number controls the speed
//   container.scrollLeft = scrollLeft - walk;
// });

// }

window.addEventListener('DOMContentLoaded', init);